import { render } from "./OutletMitra.vue?vue&type=template&id=60e38854"
import script from "./OutletMitra.vue?vue&type=script&lang=js"
export * from "./OutletMitra.vue?vue&type=script&lang=js"

import "./OutletMitra.vue?vue&type=style&index=0&id=60e38854&lang=css"

import exportComponent from "C:\\Users\\msimi\\Downloads\\tuaszone\\survey-agel-web-report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__